module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// /home/travis/build/Pedro-vk/Bet-Token-wallet/node_modules/xhr2/lib/browser.js
// module id = uJx8
// module chunks = 0